import { render, staticRenderFns } from "./Scale_Problem_presentation.vue?vue&type=template&id=5125c9fb"
import script from "./Scale_Problem_presentation.vue?vue&type=script&lang=js"
export * from "./Scale_Problem_presentation.vue?vue&type=script&lang=js"
import style0 from "./Scale_Problem_presentation.vue?vue&type=style&index=0&id=5125c9fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports